import {Component, Input } from '@angular/core';
import {cIO_MODBUS_TREE} from "../modbusData";
import {ModbuslistComponent} from "../modbuslister/modbuslist.component";


@Component({
  selector: 'app-modbusdetails',
  templateUrl: './modbusdetails.component.html',
  styleUrls: ['./modbusdetails.component.css']
})
export class ModbusdetailsComponent  {
  @Input()  modbusTree: cIO_MODBUS_TREE =  new cIO_MODBUS_TREE;
  @Input()  refNumber: number = -1;
  //modbusTree: cIO_MODBUS_TREE;


  constructor(private modbuslistComponent: ModbuslistComponent ) {
//    this.modbusTree = new cIO_MODBUS_TREE;
    modbuslistComponent.Add(this);
  }

  UpdateStatus(modbusData: cIO_MODBUS_TREE): void {
    this.modbusTree = modbusData;
  }

  GetAlarmLevel() : string
  {
    return "Warning";
  }

  ConvertValue(value: number, type: number): string {
    switch (type) {
      case  0:      // Not present in Target
      case -1:      // Not defined in JSON
        return "";
      case 5:
        return (value / 10).toString();
      default:
        return "No convert";
    }
  }

}
